(() => {
  'use strict';
  if (window.__vlxCampaignPricingReady) return;
  window.__vlxCampaignPricingReady = true;

  let cart = null;
  let requestVersion = 0;
  let refreshTimer;
  let frame;
  const watched = new WeakSet();
  const code = document.querySelector('[data-vlx-campaign-pricing]')?.dataset.code || '';

  function money(cents, currency) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function setText(node, value) {
    if (node && node.textContent !== value) node.textContent = value;
  }

  function selectedPromotion() {
    if (!code || !cart) return false;
    const entry = (cart.discount_codes || []).find(item => item.code.toUpperCase() === code);
    if (!entry) return false;
    // An empty cart reports applicable=false even after a valid discount link.
    // A better, incompatible promotion must keep its own price presentation.
    const otherApplied = (cart.discount_codes || []).some(item => item.applicable && item.code.toUpperCase() !== code);
    return !otherApplied && (entry.applicable || !(cart.total_discount > 0));
  }

  function priceRow(root, base, enabled, currency, percent) {
    if (!root || !root.parentElement) return;
    const parent = root.parentElement;
    let row = Array.from(parent.children).find(node => node.hasAttribute('data-vlx-campaign-price-row'));
    root.classList.toggle('vlx-campaign-price-base', enabled);
    if (!enabled) {
      if (row) row.hidden = true;
      return;
    }
    if (!row) {
      row = document.createElement('div');
      row.className = 'vlx-campaign-price';
      row.setAttribute('data-vlx-campaign-price-row', '');
      row.innerHTML = '<strong class="vlx-campaign-price__current" aria-label="Preis mit Rabatt"></strong>' +
        '<s class="vlx-campaign-price__original" aria-label="Preis ohne Kampagnenrabatt"></s>' +
        '<span class="vlx-campaign-price__badge"></span><span class="vlx-campaign-price__suffix"></span>';
      root.insertAdjacentElement('afterend', row);
    }
    const currentPrice = row.querySelector('.vlx-campaign-price__current');
    const originalPrice = row.querySelector('.vlx-campaign-price__original');
    const currentAmount = money(Math.round(base * (100 - percent) / 100), currency);
    const originalAmount = money(base, currency);
    setText(currentPrice, currentAmount);
    setText(originalPrice, originalAmount);
    currentPrice.setAttribute('aria-label', 'Preis mit Rabatt: ' + currentAmount);
    originalPrice.setAttribute('aria-label', 'Preis ohne Kampagnenrabatt: ' + originalAmount);
    setText(row.querySelector('.vlx-campaign-price__badge'), '−' + percent + ' %');
    const suffix = root.querySelector('.f-price-festpreis');
    setText(row.querySelector('.vlx-campaign-price__suffix'), suffix ? suffix.textContent.trim() : '');
    row.hidden = false;
  }

  function render() {
    frame = null;
    document.querySelectorAll('[data-vlx-campaign-pricing]').forEach(marker => {
      const scope = marker.closest('product-info');
      if (!scope) return;
      const block = scope.querySelector('[id^="price-"]');
      const root = block && block.querySelector('.f-price[data-vlx-price]');
      if (!block || !root) return;
      const base = Number(root.dataset.vlxPrice);
      const compare = Number(root.dataset.vlxCompare || 0);
      const percent = Number(marker.dataset.percent);
      const currency = marker.dataset.currency || 'EUR';
      const enabled = marker.dataset.eligible === 'true' && selectedPromotion() &&
        Number.isFinite(base) && base > 0 && compare <= base && cart.currency === currency;
      const amount = enabled ? money(Math.round(base * (100 - percent) / 100), currency) : '';
      const original = enabled ? money(base, currency) : '';
      const changed = (block.dataset.vlxCampaignPrice || '') !== amount ||
        (block.dataset.vlxCampaignCompare || '') !== original;
      if (enabled) {
        block.dataset.vlxCampaignPrice = amount;
        block.dataset.vlxCampaignCompare = original;
      } else {
        delete block.dataset.vlxCampaignPrice;
        delete block.dataset.vlxCampaignCompare;
      }
      priceRow(root, base, enabled, currency, percent);
      marker.hidden = !enabled;

      scope.querySelectorAll('[data-vlx-lens-mode-card][data-vlx-campaign-base-price]').forEach(card => {
        const cardBase = Number(card.dataset.vlxCampaignBasePrice);
        const cardCompare = Number(card.dataset.vlxCampaignComparePrice || 0);
        const price = card.querySelector('.vlx-lens-mode__price');
        const current = card.querySelector('.vlx-lens-mode__price-current');
        if (!price || !current || !Number.isFinite(cardBase)) return;
        const cardEnabled = enabled && cardCompare <= cardBase;
        if (cardEnabled) {
          setText(current, money(Math.round(cardBase * (100 - percent) / 100), currency));
          let strike = price.querySelector('[data-vlx-campaign-card-compare]');
          if (!strike) {
            strike = document.createElement('s');
            strike.className = 'vlx-lens-mode__price-compare';
            strike.setAttribute('data-vlx-campaign-card-compare', '');
            price.appendChild(strike);
          }
          setText(strike, money(cardBase, currency));
          strike.hidden = false;
          price.classList.add('is-sale');
          card.dataset.vlxCampaignRendered = 'true';
        } else if (card.dataset.vlxCampaignRendered) {
          setText(current, money(cardBase, currency));
          const strike = price.querySelector('[data-vlx-campaign-card-compare]');
          if (strike) strike.hidden = true;
          price.classList.toggle('is-sale', cardCompare > cardBase);
          delete card.dataset.vlxCampaignRendered;
        }
      });

      document.querySelectorAll('.sticky-atc-bar .f-price').forEach(stickyPrice => {
        priceRow(stickyPrice, base, enabled, currency, percent);
      });
      scope.querySelectorAll('[data-vx-price-receipt]').forEach(receipt => {
        let note = receipt.querySelector('[data-vlx-campaign-receipt-note]');
        if (enabled && !note) {
          note = document.createElement('p');
          note.className = 'vlx-campaign-pricing__note';
          note.setAttribute('data-vlx-campaign-receipt-note', '');
          note.textContent = '10 % Rabatt berücksichtigt';
          receipt.appendChild(note);
        }
        if (note) note.hidden = !enabled;
      });
      if (changed) document.dispatchEvent(new CustomEvent('vlx:campaign-price-change'));
      if (!watched.has(block)) {
        // Watch only direct price-root replacements, not the theme's changing suffix.
        new MutationObserver(schedule).observe(block, { childList: true });
        watched.add(block);
      }
    });
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(render);
  }

  async function refreshCart() {
    const version = ++requestVersion;
    try {
      const routesRoot = window.Shopify?.routes?.root || '/';
      const response = await fetch(routesRoot + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart unavailable');
      const result = await response.json();
      if (version !== requestVersion) return;
      cart = result;
    } catch (_) {
      if (version !== requestVersion) return;
      cart = null;
    }
    schedule();
  }

  function refreshSoon() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, 120);
  }

  function init() {
    schedule();
    refreshCart();
    const pubsub = window.FoxTheme?.pubsub;
    if (pubsub?.PUB_SUB_EVENTS?.cartUpdate) {
      pubsub.subscribe(pubsub.PUB_SUB_EVENTS.cartUpdate, refreshSoon);
    }
    if (pubsub?.PUB_SUB_EVENTS?.variantChange) {
      pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, schedule);
    }
  }

  ['variant:changed', 'vlx:lens-mode-change', 'shopify:section:load'].forEach(name => {
    document.addEventListener(name, schedule);
  });
  ['cart:updated', 'cart:refresh'].forEach(name => document.addEventListener(name, refreshSoon));
  window.addEventListener('pageshow', refreshSoon);
  window.addEventListener('focus', refreshSoon);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) refreshSoon();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
